<template lang="pug">

	#peopleComponent.section-grid()
		div(class="lg:col-span-10 lg:col-start-2")
			.people-search
				.flex-auto
					label.block Search:
					input.search-box(type="text" placeholder="Start typing..." @keyup="searchPeople($event.target.value)")
			.people-filters
				.flex-auto
					.grid.grid-cols-1.gap-3(class="md:grid-cols-3")
						.filter-col
							.filter-title Filter by Sectors:
								span.or.text-sm.text-grey OR

							select.select-list(
								ref="selectSectors"
								@change="toggleFilter('sectors', $event)"
							)
								option(selected default disabled) Select
								option(
									v-for="(sector, index) in sectors"
									:key="index"
									:value="sector.id"
								) {{ sector.title }}

						.filter-col
							span.text-sm.text-grey(class="md:hidden") OR
							.filter-title Filter by Services:
								span.or.text-sm.text-grey OR

							select.select-list(
								ref="selectServices"
								@change="toggleFilter('services', $event)"
							)
								option(selected default disabled) Select
								option(
									v-for="(service, index) in services"
									:key="index"
									:value="service.id"
								) {{ service.title }}

						.filter-col
							span.text-sm.text-grey(class="md:hidden") OR
							.filter-title Filter by Role:

							select.select-list(
								ref="selectRoles"
								@change="toggleFilter('roles', $event)"
							)
								option(selected default disabled) Select
								option(
									v-for="(role, index) in roles"
									:key="index"
									:value="role.id"
								) {{ role.title }}


							//- span.text-sm.text-grey OR

						//- .filter-opts.sectors
						//- 	ul
						//- 		li.opt(
						//- 			v-for="(sector, index) in sectors"
						//- 			:key="index"
						//- 			:value="sector.id"
						//- 		) {{ sector.title }}

						//- .filter-opts.sectors
						//- 	ul
						//- 		li.opt(
						//- 			v-for="(service, index) in services"
						//- 			:key="index"
						//- 			:value="service.id"
						//- 		) {{ service.title }}

						//- .filter-opts.sectors
						//- 	ul
						//- 		li.opt(
						//- 			v-for="(role, index) in roles"
						//- 			:key="index"
						//- 			:value="role.id"
						//- 		) {{ role.title }}

			template(v-if="isFiltered")
				.filter-display
					p
						template(v-if="niceFilters.sectors.length || niceFilters.services.length")
							span Showing people specialising in&nbsp;
							span(v-if="niceFilters.sectors.length" v-for="(sector, index) in niceFilters.sectors") 
								span.opt(title="Remove option" @click="toggleFilter('sectors', false, sector.id)") {{ sector.title }}&nbsp;
									i.fal.fa-times
								span(v-if="index < niceFilters.sectors.length - 1")
									span &nbsp;,&nbsp;
							span(v-if="niceFilters.sectors.length && niceFilters.services.length") &nbsp;or&nbsp;
							span(v-if="niceFilters.services.length" v-for="(service, index) in niceFilters.services") 
								span.opt(title="Remove option" @click="toggleFilter('services', false, service.id)") {{ service.title }}&nbsp;
									i.fal.fa-times
								span(v-if="index < niceFilters.services.length - 1")
									span &nbsp;,&nbsp;
						template(v-if="niceFilters.roles.length")
							span(v-if="niceFilters.roles.length && (niceFilters.sectors.length || niceFilters.services.length)") &nbsp;or in the&nbsp; 
							span(v-else) Showing people within the&nbsp;
							span(v-if="niceFilters.roles.length")
								template(v-for="(role, index) in niceFilters.roles") 
									span.opt(title="Remove option" @click="toggleFilter('roles', false, role.id)") {{ role.title }}&nbsp;
										i.fal.fa-times
									span(v-if="index < niceFilters.roles.length - 1")
										span &nbsp;,&nbsp;
								template(v-if="niceFilters.roles.length > 1")
									span  roles
								template(v-else)
									span  role

					p.flex.justify-end.whitespace-nowrap.text-sm.border-b-2.cursor-pointer(@click="clearFilter()" class="hover:text-orange") Clear filters

			.people-results()
				.loading-overlay(v-if="loading")
					h3 loading...

				template(v-if="isFiltered")
					transition-group(name="fade" tag="div" class="people-grid")
						a.person-card(
							v-for="(person, index) in filteredPeople"
							:href="person.url"
							:key="person.id"
						)
							.profile-img
								.hover-fill Contact
								img.aspect-square.object-cover(
									v-if="person.profile_photo"
									:alt="person.title"
									width="250" height="250"
									:src="'/img' + person.profile_photo.url + '?w=400&h=400'"
								)
								img(
									v-else
									width="250" height="250"
									:src="'/img/no-image.png?w=400&h=400'"
									alt="Not found"
								)
							h3.name {{ person.title }}
							h5.pos {{ person.position }}

				template(v-else)
					template(v-if="groupedPeople.length")
						.grouped-people
							.group.cursor-pointer(
								:class="{ 'active' : group.isOpen }"
								v-for="(group, index) in groupedPeople"
								:key="'group-' + index"
								@click="toggleGroup(group.title)"
							)
								h3.group-title {{ group.title }}
									i.fal(:class="{ 'fa-plus' : !group.isOpen, 'fa-minus' : group.isOpen }")
								transition-group(name="fade" tag="div" class="people-grid")
									a.person-card(
										v-for="(person, index) in group.members"
										:href="person.url"
										:key="person.id"
									)
										.profile-img
											.hover-fill Contact
											img.aspect-square.object-cover(
												v-if="person.profile_photo"
												:alt="person.title"
												width="250" height="250"
												:src="'/img' + person.profile_photo.url + '?w=400&h=400'"
											)
											img(
												v-else
												width="250" height="250"
												:src="'/img/no-image.png?w=400&h=400'"
												alt="Not found"
											)
										h3.name {{ person.title }}
										h5.pos {{ person.position }}

					template(v-else)
						.no-results
							p.h4 No results found
							p.text-sm.underline.cursor-pointer(@click="clearFilter()" class="hover:text-lightblue") Clear filters


</template>

<script>
const axios = require('axios');
import PeopleQuery from '../graphql/people.graphql';
import { print } from 'graphql/language/printer';
let PeopleQueryString = print(PeopleQuery);

export default {
	el: "people-component",
	name: "People",
	data() {
		return {
			loading: true,
			searchQuery: false,
			people: {
				all: [],
			},
			sectors: [],
			services: [],
			roles: [],
			roleGroups: [],
			filter: {
				active: false,
				sectors: [],
				services: [],
				roles: [],
			},
			openGroups: ["Leadership"],
			sort: {
				recent: true,
				name: false
			},
			errors: false
		}
	},
	methods: {
		getPeople() {
			return axios({
				url: '/graphql',
				method: 'post',
				data: {
					query: PeopleQueryString
				}
			})
		},
		searchPeople(search) {
			if (search.trim().length >= 3) {
				console.log('search is', search)
				this.searchQuery = search;
				console.log('query is', this.searchQuery)
			} else {
				this.searchQuery = false;
			}
		},
		resetSelectLists() {
			this.$refs.selectSectors.selectedIndex = 0
			this.$refs.selectServices.selectedIndex = 0
			this.$refs.selectRoles.selectedIndex = 0
		},
		toggleFilter(taxonomy, event, taxonomyId = false) {
			// window.scrollTo({
			// 	top: 0,
			// 	behavior: 'smooth'
			// });

			let id = (event !== false)? event.target.value : taxonomyId

			switch(taxonomy) {
				case 'sectors':
					let sector = this.sectors.find(sector => sector.id === id)
					if (sector.selected === true) {
						sector.selected = false
						this.filter.sectors = this.filter.sectors.filter(sector => sector !== id)
					} else {
						this.filter.sectors.push(id)
						sector.selected = true
					}
					break;
				case 'services':
					let service = this.services.find(service => service.id === id)
					if (service.selected === true) {
						service.selected = false
						this.filter.services = this.filter.services.filter(service => service !== id)
					} else {
						this.filter.services.push(id)
						service.selected = true
					}
					break;
				case 'roles':
					let role = this.roles.find(role => role.id === id)
					if (role.selected === true) {
						role.selected = false
						this.filter.roles = this.filter.roles.filter(role => role !== id)
					} else {
						this.filter.roles.push(id)
						role.selected = true
					}
					break;
			}
			this.resetSelectLists()

		},
		clearFilter() {
			this.filter.sectors = []
			this.filter.services = []
			this.filter.roles = []
			this.sectors.forEach(sector => {
				sector.selected = false
			})
			this.services.forEach(service => {
				service.selected = false
			})
			this.roles.forEach(role => {
				role.selected = false
			})
			this.sort.name = false
			this.sort.recent = true
		},
		toggleGroup(title) {
			if (this.openGroups.includes(title)) {
				this.openGroups = this.openGroups.filter(group => group !== title)
			} else {
				this.openGroups.push(title)
			}
		},
		sortBy(choice) {
			this.sort.recent = false
			this.sort.name = false
			switch(choice) {
				case 'recent':
					this.sort.recent = !this.sort.recent
					break;
				case 'name':
					this.sort.name = !this.sort.name
					break;
			}
		}
	},
	watch: {
		loading: {
			immediate: true,
			handler() {
				// this.loading ? document.body.classList.add('overflow-y-hidden') : document.body.classList.remove('overflow-y-hidden')
			}
		}
	},
	computed: {
		isFiltered() {
			return this.filter.sectors.length > 0 || this.filter.services.length > 0 || this.filter.roles.length > 0 || this.searchQuery !== false
		},
		niceFilters() {
			let sectors = this.sectors.filter(sector => sector.selected === true)
			sectors = sectors.map(sector => {
				return {
					id: sector.id,
					title: sector.title
				}
			})

			let services = this.services.filter(service => service.selected === true)
			services = services.map(service => {
				return {
					id: service.id,
					title: service.title
				}
			})

			let roles = this.roles.filter(role => role.selected === true)
			roles = roles.map(role => {
				return {
					id: role.id,
					title: role.title
				}
			})

			return {
				sectors: sectors,
				services: services,
				roles: roles
			}
		},
		groupedPeople() {
			let groups = []

			this.roleGroups.forEach(group => {
				let g = {}
				g.title = group.group_title
				g.members = []
				g.isOpen = this.openGroups.includes(group.group_title)

				group.included_roles.forEach(role => {
					let peopleInRole = this.people.all.filter(person => {
						let roleIds = person.roles.map(role => role.id)
						return roleIds.includes(role.id)
					})
					g.members = g.members.concat(peopleInRole)
				})
				groups.push(g)
			})
			return groups
		},
		filteredPeople() {
			let res = []

			//- Filter
			if (this.filter.sectors.length || this.filter.services.length || this.filter.roles.length || this.searchQuery !== false) {
				this.people.all.forEach(person => {
					let found = false
					if (this.filter.sectors.length && person.sectors !== null) {
						person.sectors.forEach(sector => {
							if (this.filter.sectors.includes(sector.id)) {
								found = true
							}
						});
					}
					if (this.filter.services.length && person.services !== null) {
						person.services.forEach(service => {
							if (this.filter.services.includes(service.id)) {
								found = true
							}
						});
					}
					if (this.filter.roles.length && person.roles !== null) {
						person.roles.forEach(role => {
							if (this.filter.roles.includes(role.id)) {
								found = true
							}
						});
					}
					if (found)
						res.push(person);

					if(this.searchQuery !== false) {
						if (person.title.toLowerCase().includes(this.searchQuery.toLowerCase())) {
							res.push(person);
						}
					}
				});
			}
			else {
				res = this.people.all
			}


			//- Sort

			if (this.sort.recent) {
				console.log('Sorting by recent')
				// res.sort((a, b) => {
				// 	return a.date.localeCompare(b.date)
				// })
			}

			if (this.sort.name) {
				console.log('Sorting by name')
				res.sort((a, b) => {
					return a.title.localeCompare(b.title)
				})
			} 

			return res
		}
	},
	beforeMount() {
		this.getPeople()
			.then((response) => {
				console.log(response)

				if (response.data.errors) {
					this.errors = response.data.errors
				}

				let people = []
				response.data.data.people.entries.forEach((person, index) => {
					person.original_index = index
					people.push(person)
				})
				this.people.all = people

				let sectors = []
				response.data.data.sectors.terms.forEach(sector => {
					sector.selected = false
					sectors.push(sector)
				})
				this.sectors = sectors

				let services = []
				response.data.data.services.terms.forEach(service => {
					service.selected = false
					services.push(service)
				})
				this.services = services

				let roles = []
				response.data.data.roles.terms.forEach(role => {
					role.selected = false
					roles.push(role)
				})
				this.roles = roles

				let roleGroups = []
				response.data.data.role_groups.staff_role_groups.forEach(rGroup => {
					roleGroups.push(rGroup)
				})
				this.roleGroups = roleGroups

				this.loading = false

			})
			.catch((error) => {
				console.log(error);
			})
			.then(() => {
				console.log('People loaded');
			});
	}
}
</script>
